import { formatInTimeZone, getTimezoneOffset, toZonedTime, utcToZonedTime } from "date-fns-tz"
import {
  addMinutes,
  setMinutes,
  setHours,
  startOfDay,
  addMilliseconds,
  milliseconds,
  differenceInMilliseconds,
  parseISO,
  format,
} from "date-fns"

export const UK_TIMEZONE = "Europe/London"

export const getCurrentUKDateTime = () => {
  // Get the current date and format directly to ISO format in UK timezone
  const ukNow = formatInTimeZone(new Date(), UK_TIMEZONE, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
  return ukNow
}

export const formatDateForUKTime = (dateInput) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  // Format using date-fns-tz with the UK timezone
  return formatInTimeZone(date, UK_TIMEZONE, "d MMMM yyyy")
}

export const formatTimeForUK = (dateInput) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  // Format time using date-fns-tz with UK timezone
  return formatInTimeZone(date, UK_TIMEZONE, "HH:mm")
}

export const formatDurationWithUKTimes = (startDate, endDate) => {
  const startTime = formatTimeForUK(startDate)
  const endTime = formatTimeForUK(endDate)
  return `${startTime} - ${endTime}`
}

export function getCurrentUKDateTimeObject() {
  // Using UK_TIMEZONE to display the date and time in UK times
  const UKNOW = toZonedTime(new Date(), UK_TIMEZONE)
  const minutes = UKNOW.getMinutes()
  const roundedMinutes = minutes >= 30 ? 0 : 30
  const hours = minutes >= 30 ? UKNOW.getHours() + 1 : UKNOW.getHours()
  UKNOW.setHours(hours % 24, roundedMinutes % 60, 0, 0)
  // Get start of day in UTC timezone for time difference calculation
  const dayStart = startOfDay(UKNOW)
  const dateTimeObject = {
    date: UKNOW,
    dateStr: format(UKNOW, "yyyy-MM-dd"),
    timeStr: format(UKNOW, "HH:mm"),
    timeInMilliseconds: differenceInMilliseconds(UKNOW, dayStart),
    duration: 90 * 60 * 1000, // 90 minutes in miliseconds
  }
  return dateTimeObject
}

// Improved duration formatter
export const FormatDuration = (milliseconds) => {
  const hours = Math.floor(milliseconds / 3600000)
  const minutes = Math.floor((milliseconds % 3600000) / 60000)

  if (minutes === 0) return `${hours}hr`
  return `${hours}hr${minutes}m`
}

export const isInBST = (date) => {
  return getTimezoneOffset(UK_TIMEZONE, date) === 60 * 60 * 1000
}
